"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolTip = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Tooltip_1 = tslib_1.__importDefault(require("@material-ui/core/Tooltip"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var styles_1 = require("@material-ui/core/styles");
var theme_1 = require("../../theme");
exports.ToolTip = function (_a) {
    var infoText = _a.infoText, open = _a.open, icon = _a.icon, children = _a.children, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, _c = _a.margin, margin = _c === void 0 ? '4px 12px 4px 12px' : _c, _d = _a.isCustom, isCustom = _d === void 0 ? false : _d, rest = tslib_1.__rest(_a, ["infoText", "open", "icon", "children", "placement", "margin", "isCustom"]);
    var useStyles = styles_1.makeStyles({
        customTooltip: {
            borderRadius: '0px',
            fontSize: '1.2rem',
            fontFamily: theme_1.theme.fonts.robotoRegular,
            lineHeight: '1.5rem',
            maxWidth: '200px',
            backgroundColor: theme_1.theme.colors.NTDarkGrey[700],
            margin: margin,
        },
        customPopper: {
            zIndex: 10010,
        },
    });
    var classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Tooltip_1.default, tslib_1.__assign({ title: infoText, open: open, placement: placement, classes: {
                popper: classes.customPopper,
                tooltip: classes.customTooltip,
            } }, rest), isCustom ? (react_1.default.createElement(StyledSpan, null, icon ? (react_1.default.createElement(StyledInformationIcon, { className: "icon--" + icon, "data-test-component-name": "tooltip-info-icon" })) : (children))) : (react_1.default.createElement("span", null, icon ? (react_1.default.createElement(StyledInformationIcon, { className: "icon--" + icon, "data-test-component-name": "tooltip-info-icon" })) : (children))))));
};
var StyledInformationIcon = styled_components_1.default.i(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n  font-size: 1.6rem;\n"], ["\n  color: ", ";\n  font-size: 1.6rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[900];
});
var StyledSpan = styled_components_1.default.span(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: block;\n  width: 75px;\n  margin-left: auto;\n"], ["\n  display: block;\n  width: 75px;\n  margin-left: auto;\n"])));
var templateObject_1, templateObject_2;
